module.exports = __webpack_public_path__ + "img/logo_64.png";